export default __webpack_public_path__ + "static/media/cyberhood_alt.f67f2b9e.jpg";